import React, { useEffect, useState, useMemo } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Grid,
  DialogActions,
  IconButton,
  TextField,
  Checkbox,
  Autocomplete,
  Form, 
  FormControl,
  Select,
  MenuItem,
} from '@mui/material';
import { useMain } from '../hooks/useMain';
import TableCells from 'src/components/Tables/TableCells';
import TextInputs from 'src/components/inputs/TextInputs';
import SelectInputs from 'src/components/inputs/SelectInputs';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import Popper from '@mui/material/Popper';
import CheckboxInputs from 'src/components/inputs/CheckboxInputs';
import { MdDelete } from 'react-icons/md';
import { FaRegEdit } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { setAllServices, updateServiceData, updateServiceInState } from 'src/redux/slices/servicesSlice'; // Import actions
import { getHighlightedText } from 'src/utils/textUtils';

export const TrimData = (data) => {
  if (typeof data === 'string' && data.length > 20) {
    return data.substring(0, 20) + '...';
  }
  return data;
};

const taxStatusOptions = [
  { value: 'withTax', label: 'Inclusive' },
  { value: 'withoutTax', label: 'Exclusive' },
  // { value: 'noGst', label: 'No GST' },
];

const FieldData = ({ setData, getServices, checkedServices, setCheckedServices }) => {
  const [openDialogue, setOpenDialogue] = useState(false);
  const [productData, setProductData] = useState([]);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [selectedServiceId, setSelectedServiceId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [hoveredItemId, setHoveredItemId] = useState(null);
  const [categoryOptions, setCategoryOptions] = useState([]);
const [categorySaving, setCategorySaving] = useState(false);

  const dispatch = useDispatch();

const { deleteService, updateService, setShowMessage, activeBranchId, fetchAllConsumeProducts, branchData, getAllCategories, getAppointmentPageData } = useMain();  // const data = useSelector((state) => state.service.displayedServices); // Get filtered data from Redux state
  const initialData = useSelector((state) => state.service.initialValue);
  const serviceOptions = useSelector((state) => state.service.serviceOptions);
  const hasGstNumber = Boolean(String(branchData?.gstNumber || '').trim());
 const { data, filters } = useSelector((state) => ({
    data: state.service.displayedServices, // or whatever prop you already receive
    filters: state.service.filters,
  }));
  const taxableValue = useMemo(() => {
    const p = Number(initialData.price) || 0;
    if (!hasGstNumber) {
      return p.toFixed(2);
    }
    if (initialData.taxStatus === 'withTax') {
      return (p / 1.05).toFixed(2);
    }
    return p.toFixed(2);
  }, [hasGstNumber, initialData.price, initialData.taxStatus]);

  const handleCloseDialogue = () => {
    setOpenDialogue(!openDialogue);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch(updateServiceData({ ...initialData, [name]: value })); // Dispatch to update Redux state
  };
  // Sets one text field in the service form
  const setServiceText = (field, value) => {
    dispatch(updateServiceData({ ...initialData, [field]: value }));
  };

  // Service Name: block leading spaces while typing
  const handleServiceNameChange = (e) => {
    setServiceText('serviceName', e.target.value.trimStart());
  };

  // Trims trailing spaces when the field loses focus (works for Service Name and Category)
  const makeBlurHandler = (field) => (e) => {
    const trimmed = (e.target.value || '').trim();
    if (trimmed !== e.target.value) {
      setServiceText(field, trimmed);
    }
  };

  // Trims pasted text, then inserts it at the cursor position
  const makePasteHandler = (field) => (e) => {
    e.preventDefault();
    const { selectionStart, selectionEnd, value } = e.target;
    const pasted = e.clipboardData.getData('text').trim();
    const next = (value.slice(0, selectionStart) + pasted + value.slice(selectionEnd)).trim();
    setServiceText(field, next);
  };
  const handleProductChange = (event, newValue) => {
    // Update the selected products in state
    const updatedMappedProducts = newValue.map(prod => prod._id);
    dispatch(updateServiceData({
      ...initialData,
      mappedProducts: updatedMappedProducts
    }));
  }

  // const handleUpdate = (item) => {
  //   console.log(item,'itemmssssssssssss')
  //   setSelectedServiceId(item._id);
  //   const { _id, ...rest } = item;
  //   dispatch(updateServiceData(rest)); // Dispatch data for update
  //   setOpenDialogue(!openDialogue);
  // };


  //  const handleUpdate = (item) => {
  //   setSelectedServiceId(item._id);
  //   const { _id, ...rest } = item;
  //   dispatch(updateServiceData(rest));
  //   setOpenDialogue(true);
  // };
  const handleUpdate = (item) => {
    setSelectedServiceId(item._id);
    const { _id, ...rest } = item;
    const normalizedMappedProducts = (rest.mappedProducts || []).map(mp =>
      typeof mp === 'object' ? mp._id : mp
    );
    // dispatch(updateServiceData(rest));
    dispatch(updateServiceData({
      ...rest,
      mappedProducts: normalizedMappedProducts
    }));
    setOpenDialogue(true);
  };

  //   const handleUpdateService = async () => {
  //   try {
  //     setLoading(true);
  //     const res = await updateService(
  //       selectedServiceId,
  //       initialData,
  //       `?branchId=${activeBranchId}`,
  //     );
  //     if (res?.statusCode === 200) {
  //       setShowMessage({
  //         message: res.message || 'Service updated successfully',
  //         messageType: 'success',
  //       });

  //       // Use the new reducer instead of refreshing all data
  //       dispatch(updateServiceInState({ 
  //         _id: selectedServiceId, 
  //         ...initialData 
  //       }));

  //     } else {
  //       setShowMessage({
  //         message: res.message || 'Service details not updated',
  //         messageType: 'error',
  //       });
  //     }
  //   } catch (error) {
  //     setShowMessage({ message: error.message || 'Something Went Wrong', messageType: 'error' });
  //   } finally {
  //     setLoading(false);
  //     setOpenDialogue(!openDialogue);
  //   }
  // };
const handleUpdateService = async () => {
    try {
      if (hasGstNumber && (!initialData.taxStatus || initialData.taxStatus === 'noGst' || initialData.taxStatus === '')) {
        setShowMessage({
          message: 'Tax Status is required. Please select Inclusive or Exclusive.',
          messageType: 'error',
        });
        return;
      }

            setLoading(true);

      const payload = {
        ...initialData,
        serviceName: (initialData.serviceName || '').trim(),
        category: (initialData.category || '').trim(),
        taxStatus: hasGstNumber ? initialData.taxStatus : 'noGst',
        taxableValue: taxableValue,
      };

      const res = await updateService(
        selectedServiceId,
        payload,
        `?branchId=${activeBranchId}`,
      );
      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Service updated successfully',
          messageType: 'success',
        });

        dispatch(updateServiceInState({
          _id: selectedServiceId,
          ...payload
        }));

      } else {
        setShowMessage({
          message: res.message || 'Service details not updated',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something Went Wrong', messageType: 'error' });
    } finally {
      setLoading(false);
      setOpenDialogue(!openDialogue);
    }
  };

  const handleDeleteField = (id) => {
    setDeleteId(id); // Set the ID to be deleted
    setOpenDeleteDialog(true); // Open confirmation dialog
  };

  const confirmDelete = async () => {
    try {
      const res = await deleteService(deleteId, `?branchId=${activeBranchId}`);
      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Service deleted successfully',
          messageType: 'success',
        });
        // dispatch(setAllServices(data?.filter((d) => d?._id !== deleteId))); // Update Redux state after deletion
        await getServices(); // Refresh the data after deletion
      } else {
        setShowMessage({
          message: res.message || 'Service not deleted',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Something went wrong',
        messageType: 'error',
      });
    } finally {
      setOpenDeleteDialog(false);
      setDeleteId(null);
    }
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setDeleteId(null);
  };

  const handleAllCheckboxChange = () => {
    if (isAllChecked) {
      setCheckedServices([]);
    } else {
      setCheckedServices(data);
    }
    setIsAllChecked(!isAllChecked);
  };

  const handleSignleCheckboxChange = (serviceId) => {
    if (checkedServices.length && checkedServices.some((check) => check._id === serviceId)) {
      setCheckedServices((prev) => prev.filter((check) => check._id !== serviceId));
    } else {
      const checked = data.filter((item) => item._id === serviceId);
      setCheckedServices((prev) => [...prev, ...checked]); // Create a new array
    }
  };

  useEffect(() => {
    setIsAllChecked((data?.length && checkedServices?.length === data?.length) || false);
  }, [checkedServices?.length, data?.length]);

  useEffect(() => {
    if (activeBranchId) {
      getProductData();
    }
  }, [activeBranchId]);

  useEffect(() => {
    if (activeBranchId) {
      loadCategoryOptions();
    }
  }, [activeBranchId]);

const loadCategoryOptions = async () => {
    try {
      const res = await getAppointmentPageData(activeBranchId);
      if (res?.statusCode === 200) {
        // res.data.services: [{ categoryName, image, services }, ...]
        const categories = (res.data?.services || []).map((entry) => ({
          categoryName: entry.categoryName,
        }));
        setCategoryOptions(categories);
      }
    } catch (error) {
      console.error('Failed to load categories', error);
    }
  };

  const getProductData = async () => {
    try {
      setLoading(true);
      const res = await fetchAllConsumeProducts(activeBranchId);
      if (res.statusCode === 200) {
        setProductData(res.data);
      } else {
        setShowMessage({
          message: res.message || 'Failed to fetch Product data',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Something went wrong',
        messageType: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  const sortedProducts = React.useMemo(() => {
    if (!productData?.length) return [];

    // Get currently mapped product IDs
    const mappedProductIds = initialData?.mappedProducts || [];

    // Separate products into mapped and unmapped
    const mappedProducts = productData.filter(product =>
      mappedProductIds.includes(product._id)
    );
    const unmappedProducts = productData.filter(product =>
      !mappedProductIds.includes(product._id)
    );

    // Combine with mapped products first
    return [...mappedProducts, ...unmappedProducts];
  }, [productData, initialData?.mappedProducts]);

  // Get currently selected products for Autocomplete value
  const selectedProducts = React.useMemo(() => {
    if (!initialData?.mappedProducts?.length || !productData?.length) return [];
    return productData.filter(product =>
      initialData.mappedProducts.includes(product._id)
    );
  }, [initialData?.mappedProducts, productData]);
  const serviceGridTemplate = '60px 160px 140px 120px 100px 90px 120px 140px';
  const serviceGridRowStyle = {
    display: 'grid',
    gridTemplateColumns: serviceGridTemplate,
    alignItems: 'center',
    columnGap: '4px',
  };




  return (
    <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>
      <table className="table-container mt-3">
        <thead className="table-thead">
          <tr style={serviceGridRowStyle}>
            <th style={{ padding: '8px' }}>
              <CheckboxInputs
                type={'Heading'}
                isAllChecked={isAllChecked}
                handleAllCheckboxChange={handleAllCheckboxChange}
              />
            </th>
            {['Name', 'Service For', 'Category', 'Duration', 'Price', 'Tax Status', 'Actions'].map((h, index) => {
              return (
                <th key={index} style={{ width: '100%' , textAlign: 'center'}}>
                  {h}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody className="table-tbody">
          {data.map((item) => {
            return (
              <tr key={item._id} style={serviceGridRowStyle}>
                <td style={{ padding: '8px' }}>
                  <CheckboxInputs
                    type={'content'}
                    handleSignleCheckboxChange={handleSignleCheckboxChange}
                    checkedItems={checkedServices}
                    fieldId={item?._id}
                  />
                </td>
                <td
                    style={{
                      padding: '8px',
                      position: 'relative',
                      textAlign: 'center',
                    }}
                    onMouseEnter={() => setHoveredItemId(item._id + "_serviceName")}
                    onMouseLeave={() => setHoveredItemId(null)}
                  >
                    <div
                      style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '100%',
                        cursor: 'pointer',
                      }}
                    >
                      {getHighlightedText(item?.serviceName, filters.search)}
                    </div>

                    {hoveredItemId === item._id + "_serviceName" && (
                      <div
                        style={{
                          position: 'absolute',
                          top: '100%',
                          left: 0,
                          backgroundColor: '#dfe3f8',
                          border: '1px solid #ccc',
                          padding: '6px 10px',
                          borderRadius: '5px',
                          zIndex: 100,
                          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                          whiteSpace: 'normal',
                          maxWidth: '250px',
                        }}
                      >
                        {getHighlightedText(item?.serviceName, filters.search)}
                      </div>
                    )}
                  </td>
                <td style={{ padding: '8px', textAlign: 'center' }}>{TrimData(item?.serviceFor)}</td>
                <td style={{ padding: '8px', textAlign: 'center', width: "100%", position: "relative" }}>
                  <div
                    onMouseEnter={() => setHoveredItemId(item._id + "_categoryName")}
                    onMouseLeave={() => setHoveredItemId(null)}
                    style={{ cursor: "pointer" }}
                  >
                  {getHighlightedText(TrimData(item?.category), filters.search)}

                    {hoveredItemId === item._id + "_categoryName" && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          backgroundColor: "#dfe3f8",
                          border: "1px solid #ccc",
                          padding: "8px",
                          borderRadius: "5px",
                          zIndex: 5,
                          boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                          whiteSpace: "pre-wrap",
                          maxWidth: "300px",
                        }}
                      >
                     {getHighlightedText(item?.category, filters.search)}                      </div>
                    )}
                  </div>
                </td>
                <td style={{ padding: '8px', textAlign: 'center' }}>{item?.duration ? item?.duration + ' min' : ''}</td>
                <td style={{ padding: '8px', textAlign: 'center' }}>{'Rs.' + item?.price}</td>
                <td style={{ padding: '8px', textAlign: 'center' }}>
                  {taxStatusOptions.find((opt) => opt.value === item?.taxStatus)?.label || item?.taxStatus || '-'}
                </td>
                <td style={{ width: '100%' }}>
                  <IconButton
                    onClick={() => handleUpdate(item)}
                    color="secondary"
                    title="Update"
                    style={{ marginRight: '24px' }}
                  >
                    <FaRegEdit style={{ color: '#696969', fontSize: '1rem' }} />
                  </IconButton>
                  <IconButton
                    onClick={() => handleDeleteField(item._id)}
                    color="error"
                    title="Delete"
                    style={{ marginLeft: '-33px' }}
                  >
                    <MdDelete color="#FF4D4D" style={{ fontSize: '1.2rem', marginTop: '1px' }} />
                  </IconButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
        <DialogContent>Are you sure you want to delete this Service?</DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmDelete} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openDialogue} onClose={handleCloseDialogue} maxWidth="md">
        <DialogTitle>Service Details</DialogTitle>
        <DialogContent>
          <DialogContentText>Here you can update Service details.</DialogContentText>
          <Box style={{ marginTop: '20px' }}>
            <Grid container spacing={3}>
              <Grid item xs={6} md={4}>
              <div onBlur={makeBlurHandler('serviceName')} onPaste={makePasteHandler('serviceName')}>
                <TextInputs
                  title={'Service Name'}
                  name={'serviceName'}
                  value={initialData?.serviceName}
                  handleChange={handleServiceNameChange}
                  type={'text'}
                  required={false}
                />
              </div>
            </Grid>
              <Grid item xs={6} md={4}>
                <div style={{ marginBottom: '4px', fontWeight: 600, fontSize: '15px', color: '#212529' }}>Category Name</div>
                 <div onBlur={makeBlurHandler('category')} onPaste={makePasteHandler('category')}>
                    <Autocomplete
                      freeSolo
                      options={categoryOptions.map((c) => c.categoryName)}
                      value={initialData?.category || ''}
                      onChange={(event, newValue) => {
                        dispatch(updateServiceData({
                          ...initialData,
                          category: (newValue || '').trim(),
                        }));
                      }}
                      onInputChange={(event, newValue) => {
                        dispatch(updateServiceData({
                          ...initialData,
                          category: (newValue || '').trimStart(),
                        }));
                      }}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Type or select category" />
                  )}
                />
                </div>
              </Grid>
              <Grid item xs={6} md={4}>
                  <FormControl fullWidth>
                    <label style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      marginBottom: "4px",
                      display: "inline-block",
                      color: "#212529"
                    }}>Price</label>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        border: '1px solid #ced4da',
                        borderRadius: '4px',
                        height: "57px",
                        transition: 'border-color 0.2s ease-in-out',
                        '&:hover': {
                          borderColor: '#6174DD',
                        },
                      }}
                    >
                      <span style={{ padding: '0px 8px', fontSize: '16px', color: '#666' }}>₹</span>
                      <input
                        name="price"
                        placeholder="0"
                        value={initialData?.price}
                        onChange={handleChange}
                        type="number"
                        min="0"
                        style={{
                          border: 'none',
                          outline: 'none',
                          flex: 1,
                          padding: '12px 0px',
                          fontSize: '16px',
                          background: 'transparent',
                          width: '100%'
                        }}
                      />
                      {hasGstNumber && (
                        <Select
                          name="taxStatus"
                          value={initialData?.taxStatus || 'noGst'}
                          onChange={handleChange}
                          displayEmpty
                          inputProps={{ 'aria-label': 'Without label' }}
                          sx={{
                            background: '#F0F0F0',
                            border: 'none',
                            height: '100%',
                            borderTopLeftRadius: '0px',
                            borderBottomLeftRadius: '0px',
                            borderTopRightRadius: '3px',
                            borderBottomRightRadius: '3px',
                            '& .MuiSelect-select': {
                              padding: '8px 16px',
                              paddingRight: '24px !important',
                              height: '100% !important',
                              display: 'flex',
                              alignItems: 'center'
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                              border: 'none'
                            },
                            '&:hover': {
                              background: '#e0e0e0',
                            },
                            '&.Mui-focused': {
                              background: '#e0e0e0',
                            },
                            borderLeft: '1px solid #ced4da'
                          }}
                        >
                          {taxStatusOptions.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    </Box>
                    {hasGstNumber && (
                      <Box sx={{
                        p: '8px 12px',
                        backgroundColor: '#e9ecef',
                        border: '1px solid #ced4da',
                        borderTop: 'none',
                        borderRadius: '0 0 4px 4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}>
                        <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>Taxable Value: {taxableValue}</span>
                      </Box>
                    )}
                  </FormControl>
                </Grid>
            </Grid>
          </Box>
          <Box style={{ marginTop: '20px' }}>
            <Grid container spacing={3}>
              <Grid item xs={6} md={4}>
                <TextInputs
                  title={'Duration (in minutes)'}
                  name={'duration'}
                  value={initialData?.duration}
                  handleChange={handleChange}
                  type={'number'}
                  required={false}
                />
              </Grid>
              <Grid item xs={6} md={4}>
                <SelectInputs
                  title={'Services For'}
                  options={serviceOptions}
                  name={'serviceFor'}
                  value={initialData?.serviceFor}
                  handleChange={handleChange}
                  optionTitle={'name'}
                  optionValue={'name'}
                  required={false}
                />
              </Grid>
              {/* {hasGstNumber && (
                <Grid item xs={6} md={4}>
                  <SelectInputs
                    title={'Tax Status'}
                    options={taxStatusOptions}
                    name={'taxStatus'}
                    value={initialData?.taxStatus || 'noGst'}
                    handleChange={handleChange}
                    optionTitle={'label'}
                    optionValue={'value'}
                    required={true}
                  />
                </Grid>
              )}
              {hasGstNumber && (
                <Grid item xs={6} md={4}>
                  <TextInputs
                    title={'Taxable Value'}
                    name={'taxableValue'}
                    value={taxableValue}
                    type={'text'}
                    placeholder={'0'}
                    disabled={true}
                    required={false}
                  />
                </Grid>
              )} */}
              <Grid item xs={12} md={4}>
                <div style={{ marginBottom: '5px', fontWeight: 'bold', marginTop: '5px'}}>Select Products</div>
                <Autocomplete
                  multiple
                  options={sortedProducts}
                  getOptionLabel={(option) =>
                    `${option.consumeableProductName} (${option.productVolume} ${option.productUnit})`
                  }
                  value={selectedProducts}
                  onChange={handleProductChange}
                  disableCloseOnSelect
                  PopperComponent={(props) => (
                    <Popper {...props} placement="bottom-start" />
                  )}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        checked={selected}
                        style={{ marginRight: 8 }}
                      />
                      {option.consumeableProductName} ({option.productVolume} {option.productUnit})
                    </li>
                  )}
                  renderTags={(value) =>
                    value.length > 0 ? `${value.length} products selected` : null
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // placeholder={
                      //   selectedProducts.length > 0
                      //     ? `${selectedProducts.length} products selected`
                      //     : 'Search products...'
                      // }
                      sx={{
                        '& .MuiInputBase-root': {
                          height: 52, // input ki height kam ki
                          minHeight: 'unset',
                          padding: '0 8px',
                        },
                        '& .MuiInputBase-input': {
                          padding: 0,
                        },
                      }}
                    />
                  )}
                  fullWidth
                  isOptionEqualToValue={(option, value) => option._id === value._id}
                />
              </Grid>
              <Grid item xs={6} md={4}>
                <TextInputs
                  title={'Reminder Days'}
                  name={'reminderDays'}
                  value={initialData?.reminderDays}
                  handleChange={handleChange}
                  type={'number'}
                  required={true}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          {loading ? (
            <ShowLoader />
          ) : (
            <>
              <div style={{ width: '200px', margin: '3rem auto' }}>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  target="_blank"
                  sx={{
                    background: '#6174DD',
                  }}
                  onClick={handleCloseDialogue}
                >
                  Cancel
                </Button>
              </div>
              <div style={{ width: '200px', margin: '3rem auto' }}>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  target="_blank"
                  sx={{
                    background: '#6174DD',
                  }}
                  onClick={handleUpdateService}
                >
                  Update
                </Button>
              </div>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default FieldData;

//new ui 
// import React, { useEffect, useState } from 'react';
// import {
//   Box,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   Grid,
//   DialogActions,
//   IconButton,
//   TextField,
//   Checkbox,
//   Autocomplete,
//   Card,
//   CardContent,
//   Typography,
//   Chip,
//   Tooltip,
//   MenuItem,
// } from '@mui/material';
// import { useMain } from '../hooks/useMain';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import { MdDelete, MdEdit } from 'react-icons/md';
// import { useDispatch, useSelector } from 'react-redux';
// import { updateServiceData, updateServiceInState } from 'src/redux/slices/servicesSlice';

// const ServiceCard = ({ service, isChecked, onCheck, onEdit, onDelete }) => {
//   const [isHovered, setIsHovered] = useState(false);

//   return (
//     <Card 
//       sx={{ 
//         height: '100%',
//         transition: 'all 0.2s ease-in-out',
//         border: isChecked ? '2px solid #6174DD' : '1px solid #e0e0e0',
//         '&:hover': {
//           boxShadow: 3,
//           transform: 'translateY(-2px)',
//         },
//       }}
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//     >
//       <CardContent sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
//         {/* Header with Checkbox and Actions */}
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
//           <Checkbox
//             checked={isChecked}
//             onChange={() => onCheck(service._id)}
//             sx={{ p: 0, mr: 1 }}
//           />
//           <Box sx={{ display: 'flex', gap: 0.5, opacity: isHovered ? 1 : 0.7, transition: 'opacity 0.2s' }}>
//             <Tooltip title="Edit">
//               <IconButton 
//                 size="small" 
//                 onClick={() => onEdit(service)}
//                 sx={{ color: 'text.secondary' }}
//               >
//                 <MdEdit size={16} />
//               </IconButton>
//             </Tooltip>
//             <Tooltip title="Delete">
//               <IconButton 
//                 size="small" 
//                 onClick={() => onDelete(service._id)}
//                 sx={{ color: 'error.main' }}
//               >
//                 <MdDelete size={16} />
//               </IconButton>
//             </Tooltip>
//           </Box>
//         </Box>

//         {/* Service Details */}
//         <Box sx={{ flex: 1 }}>
//           <Typography variant="h6" component="h3" sx={{ mb: 1, fontWeight: 600 }}>
//             {service.serviceName}
//           </Typography>
          
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
//             <Chip 
//               label={service.category} 
//               size="small" 
//               variant="outlined"
//               sx={{ fontSize: '0.75rem' }}
//             />
//             <Chip 
//               label={service.serviceFor} 
//               size="small" 
//               color="primary"
//               sx={{ fontSize: '0.75rem' }}
//             />
//           </Box>

//           <Box sx={{ spaceY: 1 }}>
//             <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//               <Typography variant="body2" color="text.secondary">Duration:</Typography>
//               <Typography variant="body2" fontWeight="medium">
//                 {service.duration} min
//               </Typography>
//             </Box>
//             <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//               <Typography variant="body2" color="text.secondary">Price:</Typography>
//               <Typography variant="body2" fontWeight="medium" color="success.main">
//                 Rs. {service.price}
//               </Typography>
//             </Box>
//           </Box>

//           {/* Mapped Products */}
//           {service.mappedProducts && service.mappedProducts.length > 0 && (
//             <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//               <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
//                 Products Used:
//               </Typography>
//               <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//                 {service.mappedProducts.slice(0, 2).map((product, index) => (
//                   <Chip
//                     key={index}
//                     label={product.consumeableProductName}
//                     size="small"
//                     variant="outlined"
//                     sx={{ fontSize: '0.7rem', height: 24 }}
//                   />
//                 ))}
//                 {service.mappedProducts.length > 2 && (
//                   <Chip
//                     label={`+${service.mappedProducts.length - 2} more`}
//                     size="small"
//                     sx={{ fontSize: '0.7rem', height: 24 }}
//                   />
//                 )}
//               </Box>
//             </Box>
//           )}
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };

// const FieldData = ({ data, getServices, checkedServices, setCheckedServices }) => {
//   const [openDialogue, setOpenDialogue] = useState(false);
//   const [productData, setProductData] = useState([]);
//   const [selectedServiceId, setSelectedServiceId] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
//   const [deleteId, setDeleteId] = useState(null);
//   const [deleteLoading, setDeleteLoading] = useState(false);

//   const dispatch = useDispatch();
//   const { deleteService, updateService, setShowMessage, activeBranchId, fetchAllConsumeProducts } = useMain();
  
//   const initialData = useSelector((state) => state.service.initialValue);
//   const serviceOptions = useSelector((state) => state.service.serviceOptions);

//   const handleCloseDialogue = () => {
//     setOpenDialogue(false);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     dispatch(updateServiceData({ ...initialData, [name]: value }));
//   };

//   const handleProductChange = (event, newValue) => {
//     const updatedMappedProducts = newValue.map(prod => prod._id);
//     dispatch(updateServiceData({
//       ...initialData,
//       mappedProducts: updatedMappedProducts
//     }));
//   };

//   const handleUpdate = (item) => {
//     setSelectedServiceId(item._id);
//     const { _id, ...rest } = item;
//     const normalizedMappedProducts = (rest.mappedProducts || []).map(mp =>
//       typeof mp === 'object' ? mp._id : mp
//     );
//     dispatch(updateServiceData({
//       ...rest,
//       mappedProducts: normalizedMappedProducts
//     }));
//     setOpenDialogue(true);
//   };

//   const handleUpdateService = async () => {
//     try {
//       setLoading(true);
//       const res = await updateService(
//         selectedServiceId,
//         initialData,
//         `?branchId=${activeBranchId}`,
//       );
//       if (res?.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Service updated successfully',
//           messageType: 'success',
//         });
//         dispatch(updateServiceInState({
//           _id: selectedServiceId,
//           ...initialData
//         }));
//       } else {
//         setShowMessage({
//           message: res.message || 'Service details not updated',
//           messageType: 'error',
//         });
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message || 'Something Went Wrong', messageType: 'error' });
//     } finally {
//       setLoading(false);
//       setOpenDialogue(false);
//     }
//   };

//   const handleDeleteField = (id) => {
//     setDeleteId(id);
//     setOpenDeleteDialog(true);
//   };

//   const confirmDelete = async () => {
//     try {
//       const res = await deleteService(deleteId, `?branchId=${activeBranchId}`);
//       if (res?.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Service deleted successfully',
//           messageType: 'success',
//         });
//         await getServices();
//       } else {
//         setShowMessage({
//           message: res.message || 'Service not deleted',
//           messageType: 'error',
//         });
//       }
//     } catch (error) {
//       setShowMessage({
//         message: error.message || 'Something went wrong',
//         messageType: 'error',
//       });
//     } finally {
//       setOpenDeleteDialog(false);
//       setDeleteId(null);
//     }
//   };

//   const handleCheck = (serviceId) => {
//     const service = data.find((s) => s._id === serviceId);
//     if (checkedServices.some((s) => s._id === serviceId)) {
//       setCheckedServices((prev) => prev.filter((s) => s._id !== serviceId));
//     } else {
//       setCheckedServices((prev) => [...prev, service]);
//     }
//   };

//   const handleCheckAll = () => {
//     if (checkedServices.length === data.length && data.length > 0) {
//       setCheckedServices([]);
//     } else {
//       setCheckedServices([...data]);
//     }
//   };

//   useEffect(() => {
//     if (activeBranchId) {
//       getProductData();
//     }
//   }, [activeBranchId]);

//   const getProductData = async () => {
//     try {
//       setLoading(true);
//       const res = await fetchAllConsumeProducts(activeBranchId);
//       if (res.statusCode === 200) {
//         setProductData(res.data);
//       } else {
//         setShowMessage({
//           message: res.message || 'Failed to fetch Product data',
//           messageType: 'error',
//         });
//       }
//     } catch (error) {
//       setShowMessage({
//         message: error.message || 'Something went wrong',
//         messageType: 'error',
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const sortedProducts = React.useMemo(() => {
//     if (!productData?.length) return [];
//     const mappedProductIds = initialData?.mappedProducts || [];
//     const mappedProducts = productData.filter(product =>
//       mappedProductIds.includes(product._id)
//     );
//     const unmappedProducts = productData.filter(product =>
//       !mappedProductIds.includes(product._id)
//     );
//     return [...mappedProducts, ...unmappedProducts];
//   }, [productData, initialData?.mappedProducts]);

//   const selectedProducts = React.useMemo(() => {
//     if (!initialData?.mappedProducts?.length || !productData?.length) return [];
//     return productData.filter(product =>
//       initialData.mappedProducts.includes(product._id)
//     );
//   }, [initialData?.mappedProducts, productData]);

//   return (
//     <Box>
//       {/* Services Grid */}
//       <Grid container spacing={2}>
//         {data.map((service) => (
//           <Grid item xs={12} sm={6} md={4} lg={3} key={service._id}>
//             <ServiceCard
//               service={service}
//               isChecked={checkedServices.some((s) => s._id === service._id)}
//               onCheck={handleCheck}
//               onEdit={handleUpdate}
//               onDelete={handleDeleteField}
//             />
//           </Grid>
//         ))}
//       </Grid>

//       {/* Edit Service Dialog */}
//       <Dialog 
//        open={openDialogue} 
//        onClose={handleCloseDialogue} 
//        maxWidth="md" 
//        fullWidth  
//         sx={{
//     '& .MuiDialog-paper': {
//       width: '600px',
//       maxWidth: '100%'
//     }
//   }}>
//         <DialogTitle>Service Details</DialogTitle>
//         <DialogContent>
//           <DialogContentText sx={{ mb: 3 }}>
//             Here you can update Service details.
//           </DialogContentText>
//           <Grid container spacing={3}>
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Service Name"
//                 name="serviceName"
//                 value={initialData?.serviceName || ''}
//                 onChange={handleChange}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Category Name"
//                 name="category"
//                 value={initialData?.category || ''}
//                 onChange={handleChange}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Price"
//                 name="price"
//                 type="number"
//                 value={initialData?.price || ''}
//                 onChange={handleChange}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Duration (in minutes)"
//                 name="duration"
//                 type="number"
//                 value={initialData?.duration || ''}
//                 onChange={handleChange}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 select
//                 label="Services For"
//                 name="serviceFor"
//                 value={initialData?.serviceFor || ''}
//                 onChange={handleChange}
//               >
//                 {serviceOptions.map((option) => (
//                   <MenuItem key={option.name} value={option.name}>
//                     {option.name}
//                   </MenuItem>
//                 ))}
//               </TextField>
//             </Grid>
//             <Grid item xs={12}>
//               <Autocomplete
//                 multiple
//                 options={sortedProducts}
//                 getOptionLabel={(option) =>
//                   `${option.consumeableProductName} (${option.productVolume} ${option.productUnit})`
//                 }
//                 value={selectedProducts}
//                 onChange={handleProductChange}
//                 disableCloseOnSelect
//                 renderOption={(props, option, { selected }) => (
//                   <li {...props}>
//                     <Checkbox checked={selected} />
//                     {option.consumeableProductName} ({option.productVolume} {option.productUnit})
//                   </li>
//                 )}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     label="Select Products"
//                     placeholder="Search products..."
//                   />
//                 )}
//                 fullWidth
//                 isOptionEqualToValue={(option, value) => option._id === value._id}
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions sx={{ p: 3, gap: 1 }}>
//           <Button onClick={handleCloseDialogue} variant="outlined">
//             Cancel
//           </Button>
//           <Button 
//             onClick={handleUpdateService} 
//             variant="contained" 
//             disabled={loading}
//             sx={{ background: '#6174DD' }}
//           >
//             {loading ? 'Updating...' : 'Update'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Delete Confirmation Dialog */}
//       <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
//         <DialogTitle>Delete Service</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Are you sure you want to delete this service? This action cannot be undone.
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
//           <Button onClick={confirmDelete} color="error" variant="contained">
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default FieldData;
